module.exports = __webpack_public_path__ + "img/Hackathon Icon - charcoal.4f4b3611.svg";